<template>
    <div class="con">
      <br>
        <div class="rounded-background-box">
          <div class="left-rounded-column">
            <div class="product">
              <router-link to="/amethyst">
                <img class="tablet1 float" src="/AMT2logo_white_bg.png" alt="Amethyst" style="cursor: pointer;" loading="lazy">
              </router-link>
        </div>
      </div>
      <div class="right-rounded-column">
        <div class="product-info">
          
            <p>South Africa’s Leading Telephone Call Recording System and Quality Management Software. No matter the reason why you need call recording in your business. Amethyst provides the ultimate in security, mobility, and scalability.</p> 
            <p>For more information, <router-link class="link-active" to="/amethyst" style="font-weight:600;">click here</router-link></p>
    
        </div> 
        </div>
        </div>
        <div class="rounded-background-box">
      <div class="left-rounded-column">
        <div class="product">
          <router-link to="/irecall">
            <img class="tablet float" src="/cloud_irecall_logo.png" alt="Irecall" style="cursor: pointer;" loading="lazy">
          </router-link>
        </div>
      </div>
      <div class="right-rounded-column">
        <div class="product-info">
            
            <p>iReCall is our cloud-based solution and provides options for Call Recording, Telephone Management Services and Cloud archiving. Datatex staff will manage your complete solution.</p> 
            <p>For more information, <router-link class="link-active1" to="/irecall" style="font-weight:600;">click here</router-link></p>
    
        </div>
        </div>
        </div>
        <div class="rounded-background-box">
      <div class="left-rounded-column">
        <div class="product">
          <router-link to="/tes">
            <img class="tablet float" src="/TES Image new.png" alt="TES" style="cursor: pointer;" loading="lazy">
          </router-link>
        </div>
      </div>
      <div class="right-rounded-column">
        <div class="product-info">
            
            <p>TES unifies branch data, allocates billing per user, and enables call classification for accurate client billing. It includes a company-wide phone book, multi-tier billing, detailed reports, bulk email tools, and user access to call and usage data.</p> 
            <p>For more information, <router-link class="link-active2" to="/tes" style="font-weight:600;">click here</router-link></p>
    
        </div>
        </div>
     </div>
        <div class="rounded-background-box">
      <div class="left-rounded-column">
        <div class="product">
          <router-link to="/tng">
            <img class="tablet2 float" src="/TNG Image new.png" alt="TES" style="cursor: pointer;" loading="lazy">
          </router-link>
        </div>
      </div>
      <div class="right-rounded-column">
        <div class="product-info">
            
            <p>TNG can help companies cut telephone costs with detailed reports and abuse alerts based on call cost, duration, and response time. It's web-based, supports up to 10 concurrent users, and includes full access control for secure data management.</p> 
            <p>For more information, <router-link class="link-active3" to="/tng" style="font-weight:600;">click here</router-link></p>
    
        </div>
        </div>
      </div>
    </div>
    <br><br>
</template>

<script>
export default {
  
}
</script>

<style scoped>

h3{  
  letter-spacing: -0.5px;
  font-size: 24px;
  font-weight: 300;
  color: #444;
}

h2{
  letter-spacing: -0.5px;
  font-size: 20px;
  font-weight: 600;
  color: #353535;
}

p{
  letter-spacing: 0.3px;
  font-size: 22px;
  font-weight: 400;
  color: #000;
}

.rounded-background-box {
  margin: 40px auto;
  width: 1025px;
  height: 290px;
  background-color: #ddd;
  border-radius: 50px;
  box-shadow: 0 5px 30px #555;
  z-index:2;
  transition: 0.3s ease-in-out;
}
.rounded-background-box:hover {
  transform: scale(1.03);
    box-shadow: 0 5px 30px #000;
}
.left-rounded-column {
  position: relative;
  float: left;
  border-radius: 25px 0px 0px 25px;
  height: 290px;
 }

.right-rounded-column{
  position: relative;
  float: right;
  width: 640px;
  height: 290px;
  /* border-radius: 0px 25px 25px 0px; */
    display: flex;
  align-items: center;   /* vertical centering */
  justify-content: center; /* horizontal centering */

}

.link-active{
  text-decoration: none;
  color: purple;
  transition: 1s ease-in-out;
}
.link-active1{
  text-decoration: none;
  color: red;
  transition: 1s ease-in-out;
}
.link-active2{
  text-decoration: none;
  color: darkgreen;
  transition: 1s ease-in-out;
}
.link-active3{
  text-decoration: none;
  color: rgb(0, 83, 128);
  transition: 1s ease-in-out;
}



.link-active::after{
  content: "";
  position: absolute;
  bottom: 3px;
  left: 85%;
  width: 0;
  height: 3px;
  background-color: purple;
  transform: translateX(-50%);
  transition: width 0.3s ease, left 0.3s ease;
}
.link-active1::after{
  content: "";
  position: absolute;
  bottom: 3px;
  left: 85%;
  width: 0;
  height: 3px;
  background-color: red;
  transform: translateX(-50%);
  transition: width 0.3s ease, left 0.3s ease;
}
.link-active2::after{
  content: "";
  position: absolute;
  bottom: 3px;
  left: 85%;
  width: 0;
  height: 3px;
  background-color: darkgreen;
  transform: translateX(-50%);
  transition: width 0.3s ease, left 0.3s ease;
}
.link-active3::after {
  content: "";
  position: absolute;
  bottom: 3px;
  left: 85%;
  width: 0;
  height: 3px;
  background-color: rgb(0, 83, 128);
  transform: translateX(-50%);
  transition: width 0.3s ease, left 0.3s ease;
}

.link-active:hover{
  transition: 0.3s ease-in-out;
  transform: scale(1.3);
}
.link-active1:hover{
  transition: 0.3s ease-in-out;
  transform: scale(1.3);
}
.link-active2:hover{
  transition: 0.3s ease-in-out;
  transform: scale(1.3);
}
.link-active3:hover{
  transition: 0.3s ease-in-out;
  transform: scale(1.3);
}

.link-active:hover::after,
.link-active1:hover::after,
.link-active2:hover::after,
.link-active3:hover::after {
  width: 30%; /* or 100% if you want it full */
}

.product-info{
  display: inline-block;
  position: relative;
  height: auto;
  margin-left: 60px;
  text-align: justify;
  text-justify: inter-word;
}

.product-info p{
  display: inline-block;
  position: relative;
  margin-right: 60px;
}

.product-info h1{
  line-height: 40px;
}

.product{
  position: relative;
  width: 150px;
  height: auto;
  background-color: transparent;
  z-index: 100;
}

.tablet{
  position: absolute;
  width: 400px;
  height: auto;
  background-color: transparent;
  align-items: center;
  margin-left: 40px;
  margin-top: 50px;
}
.tablet1{
  position: absolute;
  width: 400px;
  height: auto;
  background-color: transparent;
  align-items: center;
  margin-left: 40px;
  margin-top: 70px;
}
.tablet2{
  position: absolute;
  width: 400px;
  height: auto;
  background-color: transparent;
  align-items: center;
  margin-left: 40px;
  margin-top: 30px;
}


@media (min-width: 2000px) {
    .rounded-background-box, .right-rounded-column {
        width: 70%;
    }

}

/* Responsive tweaks */
@media (max-width: 768px) {
  .rounded-background-box {
    flex-direction: column;
    border-radius: 30px;
    box-shadow: 0 3px 15px #444;
    width: 100%;
  }

  .left-rounded-column{
    padding: 05px;
    padding-top: 90px;
  }

  .right-rounded-column {
    width: 50%;
    text-align: center;
  }

  .product-info p {
    margin: 0;
    padding-right: 10px;

  }

  p {
    font-size: 10px;
    text-align: left;

  }

  .tablet1, .tablet2, .tablet {
    max-width: 180px;
    margin: 0 auto;
    margin-left: 10px;

  }
}

.margin-top-10 {
  padding-top:10px;
}
.margin-bot-10 {
  padding-bottom:10px;
}

</style>